var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinutebotsLogoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1466,
    height: 1200,
    viewBox: "0 0 1466 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "#ee4538",
    stroke: "none",
    d: "M 155.537796 437.321838 L 208.862762 347.419861 L 244.409164 347.419861 L 244.409164 439.157654 L 262.595703 439.157654 L 262.595703 460.403931 L 244.409164 460.403931 L 244.409164 490.034851 L 217.032745 490.034851 L 217.032745 460.403931 L 155.537796 460.403931 L 155.537796 437.321838 Z M 217.032745 439.157654 L 217.032745 377.254761 L 216.624786 377.254761 L 181.271622 439.157654 L 217.032745 439.157654 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#ee4538",
    stroke: "none",
    d: "M 363.448273 368.666077 L 308.491455 368.666077 L 307.879517 399.112976 C 311.143188 398.501038 315.437531 397.685059 320.95578 397.685059 C 340.978119 397.685059 366.926666 407.078979 366.926666 444.063965 C 366.926666 470.82843 348.128204 492.482666 311.347198 492.482666 C 300.321472 492.482666 287.449188 490.64679 278.044586 488.403015 L 278.656525 462.862427 C 285.602631 465.718201 295.415192 470.012512 307.879517 470.012512 C 322.791595 470.012512 338.315643 463.066406 338.315643 444.879883 C 338.315643 426.48938 321.975677 420.155212 305.624969 420.155212 C 296.843048 420.155212 288.469086 421.389893 280.095123 424.041626 L 281.52298 347.419861 L 363.448273 347.419861 L 363.448273 368.666077 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    fill: "#ee4538",
    stroke: "none",
    d: "M 383.094879 463.474365 C 392.896698 467.360779 403.525208 470.012512 414.765625 470.012512 C 426.607269 470.012512 444.793793 464.290283 444.793793 449.786194 C 444.793793 433.027527 431.51355 427.509277 413.327026 427.509277 L 399.434845 427.509277 L 399.434845 405.039124 L 412.511108 405.039124 C 431.717529 405.039124 444.181854 398.705017 444.181854 386.240662 C 444.181854 371.940491 432.533447 367.4422 419.661163 367.4422 C 408.431488 367.4422 397.598999 370.104675 387.582458 375.000244 L 385.950623 352.122131 C 397.39502 347.62384 411.083252 344.972046 425.791351 344.972046 C 443.365936 344.972046 472.782166 351.102234 472.782166 381.53833 C 472.782166 400.948792 460.736542 410.149414 446.22168 415.667603 L 446.22168 416.075623 C 464.408203 418.523376 473.394104 432.619568 473.394104 449.990173 C 473.394104 483.904724 442.550018 492.482666 418.845245 492.482666 C 406.38092 492.482666 392.08078 490.850769 381.452271 487.791077 L 383.094879 463.474365 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    fill: "#ee4538",
    stroke: "none",
    d: "M 577.381592 373.164429 C 569.823486 369.900696 562.061462 367.4422 552.463623 367.4422 C 527.739014 367.4422 519.354309 390.331055 518.53833 411.577271 L 518.946289 411.985229 C 525.688416 402.183411 534.481079 397.685059 546.537476 397.685059 C 573.50592 397.685059 588.21405 414.841003 588.21405 441.208252 C 588.21405 472.052307 573.097961 492.482666 540.815247 492.482666 C 501.178497 492.482666 492.385834 459.588013 492.385834 426.081421 C 492.385834 387.464539 504.850159 344.972046 551.025024 344.972046 C 561.449524 344.972046 571.251404 346.603943 581.063965 350.082336 L 577.381592 373.164429 Z M 520.996887 445.89978 C 520.996887 459.384033 526.719055 471.236389 540.815247 471.236389 C 554.09552 471.236389 559.613708 458.364136 559.613708 445.695801 C 559.613708 431.80365 553.891541 418.931335 540.203308 418.931335 C 526.311096 418.931335 520.996887 431.59967 520.996887 445.89978 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    fill: "#231f20",
    stroke: "none",
    d: "M 13.620586 523.315979 L 59.387512 523.315979 L 93.302063 631.404541 L 93.71003 631.404541 L 127.62458 523.315979 L 173.39151 523.315979 L 173.39151 665.931091 L 146.015091 665.931091 L 146.015091 548.24469 L 145.607132 548.24469 L 107.194252 665.931091 L 79.817841 665.931091 L 41.404964 548.24469 L 40.996998 548.652649 L 40.996998 665.931091 L 13.620586 665.931091 L 13.620586 523.315979 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    fill: "#231f20",
    stroke: "none",
    d: "M 202.700378 523.315979 L 231.311417 523.315979 L 231.311417 665.931091 L 202.700378 665.931091 L 202.700378 523.315979 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    fill: "#231f20",
    stroke: "none",
    d: "M 259.256836 523.315979 L 294.406006 523.315979 L 348.750885 629.965942 L 349.158844 629.965942 L 349.158844 523.315979 L 376.535278 523.315979 L 376.535278 665.931091 L 341.6008 665.931091 L 287.051941 559.281067 L 286.643982 559.281067 L 286.643982 665.931091 L 259.256836 665.931091 L 259.256836 523.315979 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    fill: "#231f20",
    stroke: "none",
    d: "M 405.371765 523.315979 L 433.982819 523.315979 L 433.982819 605.659973 C 433.982819 629.965942 441.744812 645.908691 463.602997 645.908691 C 485.471924 645.908691 493.233948 629.965942 493.233948 605.659973 L 493.233948 523.315979 L 521.83429 523.315979 L 521.83429 614.441956 C 521.83429 652.650757 500.180054 668.378845 463.602997 668.378845 C 427.036713 668.378845 405.371765 652.650757 405.371765 614.441956 L 405.371765 523.315979 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    fill: "#231f20",
    stroke: "none",
    d: "M 578.143799 545.796875 L 537.2724 545.796875 L 537.2724 523.315979 L 647.604736 523.315979 L 647.604736 545.796875 L 606.744141 545.796875 L 606.744141 665.931091 L 578.143799 665.931091 L 578.143799 545.796875 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    fill: "#231f20",
    stroke: "none",
    d: "M 663.450867 523.315979 L 747.619934 523.315979 L 747.619934 545.796875 L 692.051147 545.796875 L 692.051147 580.935364 L 742.928345 580.935364 L 742.928345 603.405457 L 692.051147 603.405457 L 692.051147 643.460938 L 748.027893 643.460938 L 748.027893 665.931091 L 663.450867 665.931091 L 663.450867 523.315979 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    fill: "#231f20",
    stroke: "none",
    d: "M 978.966736 523.315979 L 1028.813354 523.315979 C 1047.203857 523.315979 1074.78418 528.630249 1074.78418 559.893066 C 1074.78418 576.844971 1063.339844 588.697388 1046.387939 591.767822 L 1046.387939 592.17572 C 1065.79834 594.011536 1079.078613 607.08783 1079.078613 624.662476 C 1079.078613 660.616821 1046.795898 665.931091 1028.813354 665.931091 L 978.966736 665.931091 L 978.966736 523.315979 Z M 1007.567078 580.935364 L 1019.215454 580.935364 C 1031.271851 580.935364 1046.18396 578.283569 1046.18396 563.564758 C 1046.18396 547.020813 1031.67981 545.796875 1018.603516 545.796875 L 1007.567078 545.796875 L 1007.567078 580.935364 Z M 1007.567078 643.460938 L 1021.051331 643.460938 C 1034.331543 643.460938 1050.467529 640.186523 1050.467529 623.642517 C 1050.467529 605.048035 1035.35144 602.18158 1021.051331 602.18158 L 1007.567078 602.18158 L 1007.567078 643.460938 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    fill: "#231f20",
    stroke: "none",
    d: "M 1163.634155 520.868225 C 1208.381104 520.868225 1233.513794 551.100403 1233.513794 594.215576 C 1233.513794 637.33075 1208.789063 668.378845 1163.634155 668.378845 C 1117.867188 668.378845 1093.754517 637.942688 1093.754517 594.215576 C 1093.754517 550.488464 1118.275146 520.868225 1163.634155 520.868225 Z M 1163.634155 645.908691 C 1192.857056 645.908691 1203.678833 619.960144 1203.678833 594.215576 C 1203.678833 569.082947 1192.041138 543.338379 1163.634155 543.338379 C 1135.237793 543.338379 1123.589355 569.082947 1123.589355 594.215576 C 1123.589355 619.960144 1134.421875 645.908691 1163.634155 645.908691 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    fill: "#231f20",
    stroke: "none",
    d: "M 1280.676392 545.796875 L 1239.804932 545.796875 L 1239.804932 523.315979 L 1350.137329 523.315979 L 1350.137329 545.796875 L 1309.276733 545.796875 L 1309.276733 665.931091 L 1280.676392 665.931091 L 1280.676392 545.796875 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    fill: "#231f20",
    stroke: "none",
    d: "M 1443.678833 551.468567 C 1434.692871 547.592896 1424.67627 545.338379 1414.670532 545.338379 C 1404.85791 545.338379 1392.189575 549.632751 1392.189575 565.156738 C 1392.189575 589.881409 1454.71521 579.456909 1454.71521 627.274414 C 1454.71521 658.53717 1429.990601 670.378845 1401.186279 670.378845 C 1385.651489 670.378845 1378.705444 668.338989 1364.609253 664.871338 L 1367.271729 639.126709 C 1377.073608 644.430237 1388.313965 647.908691 1399.543701 647.908691 C 1410.376099 647.908691 1424.880249 642.390442 1424.880249 629.518127 C 1424.880249 602.345764 1362.365356 613.586182 1362.365356 566.380615 C 1362.365356 534.516663 1387.090088 522.868225 1412.212036 522.868225 C 1424.47229 522.868225 1435.916748 524.500122 1446.341187 527.978516 L 1443.678833 551.468567 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flowRoot4859"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36",
    fill: "#ee4538",
    stroke: "none",
    d: "M 860.426025 322.561035 L 1201.944458 199.812134 L 875.671936 598.950073 L 845.210083 598.950073 L 518.907593 199.812134 L 860.426025 322.561035 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path52",
    fill: "#ee4538",
    stroke: "none",
    d: "M 860.426025 877 L 1202.376587 997.376099 L 990.069763 1175.175537 L 730.812317 1175.175537 L 518.475464 997.376099 L 860.426025 877 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path60",
    fill: "#373535",
    stroke: "#231f20",
    strokeWidth: 34.143353,
    strokeLinecap: "round",
    d: "M 518.908569 199.812805 L 730.97522 22.238037"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 34.143353,
    strokeLinecap: "round",
    d: "M 989.905151 22.237549 L 730.975403 22.237549"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path68",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 34.143353,
    strokeLinecap: "round",
    d: "M 1201.943604 199.812805 L 989.905212 22.238037"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path72",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 34.143353,
    strokeLinecap: "round",
    d: "M 875.671631 598.950378 L 1201.94397 199.812439"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path76",
    fill: "#373535",
    stroke: "#231f20",
    strokeWidth: 34.143353,
    d: "M 1201.943604 997.601318 L 875.671265 598.950745"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path80",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 34.143353,
    strokeLinecap: "round",
    d: "M 989.905151 1175.176514 L 1201.943604 997.601685"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path84",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 34.143353,
    strokeLinecap: "round",
    d: "M 730.975586 1175.176514 L 989.905396 1175.176514"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path88",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 34.143353,
    strokeLinecap: "round",
    d: "M 518.908569 997.601318 L 730.97522 1175.176147"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path92",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 34.143353,
    strokeLinecap: "round",
    d: "M 845.209351 598.950378 L 518.908813 997.600952"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path96",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 34.143353,
    strokeLinecap: "round",
    d: "M 518.908569 199.812805 L 845.209167 598.950745"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    fill: "#ee4538",
    stroke: "none",
    d: "M 858.753784 1023.00415 C 846.632202 1023.00415 836.803467 1013.175476 836.803467 1001.053894 L 836.803467 352.846252 C 836.803467 340.72467 846.632202 330.895996 858.753784 330.895996 C 870.875366 330.895996 880.704041 340.72467 880.704041 352.846252 L 880.704041 1001.053894 C 880.704041 1013.175476 870.875366 1023.00415 858.753784 1023.00415 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flowRoot1267"
  }), /*#__PURE__*/React.createElement("g", {
    id: "flowRoot1279"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinutebotsLogoRed);
export default __webpack_public_path__ + "static/media/minutebots-logo-red.a3edb20dbd2329cd56cb98162adbbf41.svg";
export { ForwardRef as ReactComponent };